
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from "axios";
// import Modal from 'react-modal';
import Stepper from './Stepper';
import Step1 from './Steps/Step1';
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';
import FormCreator from './Steps/FormCreator';

// import FormBuilderJQ from './Steps/FormBuilderJQ';
import FormBuilderJQstart from './Steps/FormBuilderJQStart';
// import FormBuilderJQFinish from './Steps/FormBuilderJQFinish';





import { Typography, Button } from '@material-ui/core';

import Modal from 'react-responsive-modal';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import bxFavicon from '../../../assets/images/myicon.png'

class Main extends Component {

    state = {
        activeStep: 0,
        isLoggedIn: false,
        groupNameToStore: '',
        selectedGroup: null,
        createGroupName: '',
        errorMessage: '',
        widget: '',
        groupMailbox: '',
        selectType: '0',
        show: false,
        deliveryMethod: '1',
        form: null,

        formJq: null,
        fieldsCount:0
    }


    handleSelectTypeChange = (e) => {
        this.resetErrorMessage();
        const selectType = e.target.value;
        if (selectType !== this.state.selectType) {
            this.setState({ selectType });
        }
    }

    handleSelectTypeByClick = (selectType) => {
        this.resetErrorMessage();
        if (selectType !== this.state.selectType) {
            this.setState({ selectType });
        }
    }


    resetErrorMessage = () => {
        if (this.state.errorMessage.trim()) {
            this.setState({ errorMessage: '' });
        }
    }

    handleSetErrorMessage = (errorMessage) => {
        this.setState({ errorMessage });
    }

    handleSetCreateGroupName = (createGroupName) => {
        if (createGroupName && createGroupName.trim()) {
            this.setState({ createGroupName });
        }
    }

    componentDidMount() {
        this.setFavicon(bxFavicon);

        let widgetIdFromLocalStorage = sessionStorage.getItem('widget-resp') || '';
        let groupMailBoxFromLocalStorage = sessionStorage.getItem('group-mail-box') || '';
        let groupNameFromLocalStorage = sessionStorage.getItem('group-name') || '';

        this.setState({
            widget: widgetIdFromLocalStorage,
            groupMailbox: groupMailBoxFromLocalStorage,
            groupNameToStore: groupNameFromLocalStorage
        })
        if (widgetIdFromLocalStorage != '') {
            this.setState({ activeStep: 3 })
        }
    }

    componentDidUpdate(prevProps) {
        const { user } = this.props;
        const { activeStep } = this.state;
        if ((prevProps.user.isLogin !== user.isLogin) && user.isLogin && activeStep == 0) {
            this.handleNext();
        }
    }

    handleNext = () => {
        const { activeStep } = this.state;
        this.setState({ activeStep: activeStep + 1 });
    }

    // handleBack = () => {
    //     this.resetErrorMessage();
    //     this.setState({ selectedGroup: null, createGroupName: '' })
    //     this.setState(state => ({ activeStep: state.activeStep - 1 }));
    // }

    handleBack = () => {
        this.resetErrorMessage();
        // this.setState({ selectedGroup: null, createGroupName: '' })
        this.setState(state => ({ activeStep: state.activeStep - 1 }));
    }

    handleGroupSelect = (data) => {
        this.setState({ selectedGroup: data })
        this.resetErrorMessage()
    }

    BackFromWidget = () => {
        sessionStorage.setItem('widget-resp', '');
        sessionStorage.setItem('group-mail-box', '');
        this.setState({ widget: '' , activeStep: 1})
    }

    onStep2Click = (selectType, createGroupRef) => {
        const { selectedGroup } = this.state;
        if (selectType === '0') {
            if (selectedGroup && selectedGroup.id) {
                this.resetErrorMessage();
                this.handleNext();
            } else {
                this.setState({ errorMessage: 'Please select group' })
            }
        } else {
            if (createGroupRef.trim()) {
                this.handleSetCreateGroupName(createGroupRef)
                this.handleNext();
            } else {
                // handleSetErrorMessage('Please enter group name');
                this.setState({ errorMessage: 'Please enter group name' })
            }
        }
    }

    handleGroupSend = (usersUrlInput) => {
        let data = this.state.selectedGroup;
        console.log(data)
        this.setState({ groupNameToStore: data.groupName })
        sessionStorage.setItem('group-name', data.groupName)
        if (usersUrlInput && usersUrlInput.trim()) {
            this.resetErrorMessage()
            data.domain = usersUrlInput;
            data.widgetType = parseInt(this.state.deliveryMethod)
            // data.formSchema = this.state.form
            data.formSchema = this.state.formJq
            console.log(data)
            axios.post('/api/widget/create', data)
                .then((resp) => {
                    console.log(resp)
                    sessionStorage.setItem('widget-resp', resp.data.widgetText)
                    sessionStorage.setItem('group-mail-box', resp.data.group_mailbox)
                    this.setState({ widget: resp.data.widgetText, groupMailbox: resp.data.group_mailbox })
                    this.showModal(usersUrlInput);
                }).catch((err) => {
                    this.setState({ errorMessage: err.message })
                    console.log(err)
                })

        } else {
            this.setState({ errorMessage: 'Enter Domain Please' })
        }

    }

    onCreateWidget = (usersUrlInput) => {
        if (!this.state.widget) {
            if (this.state.selectType === "0") {
                this.handleGroupSend(usersUrlInput);
            } else {
                this.onCreateGroupHandler(usersUrlInput);
            }
        } else {
            this.showModal(usersUrlInput);
        }
    }

    onCreateGroupHandler = (usersUrlInput) => {
        if (usersUrlInput.trim()) {
            const { user: { email } } = this.props;
            console.log(email)
            console.log(usersUrlInput)
            this.setState({ groupNameToStore: this.state.createGroupName })
            const data = {
                email: email,
                domain: usersUrlInput,
                groupName: this.state.createGroupName,
                widgetType: parseInt(this.state.deliveryMethod),
                // formSchema: this.state.form
                formSchema: this.state.formJq
            }
            console.log(data)
            axios.post('/api/widget/create', data)
                .then((resp) => {
                    console.log(resp)
                    sessionStorage.setItem('widget-resp', resp.data.widgetText)
                    sessionStorage.setItem('group-mail-box', resp.data.group_mailbox)
                    sessionStorage.setItem('group-name', this.state.createGroupName)
                    this.setState({ widget: resp.data.widgetText, groupMailbox: resp.data.group_mailbox })
                    this.showModal(usersUrlInput);
                }).catch((err) => {
                    this.setState({ errorMessage: err.message })
                    console.log(err)
                })
        } else {
            this.setState({ errorMessage: 'Enter Domain Please' })
        }
    }

    showModal = (usersUrlInput) => {
        if (usersUrlInput.trim()) {
            this.setState({
                show: !this.state.show,
                usersUrl: usersUrlInput
            })
        } else {
            this.setState({ errorMessage: 'You must enter url in order to get widget' })
        }
    }

    handleCloseModal = () => {
        this.setState({ show: false });
    }

    formCreatorClick = (form) => {
        this.setState({ form: form })
        this.handleNext();
    }

    handeNextFromFormBuilderJQ = (form)=>{
        // console.log(form)
        this.setState({formJq: form})
        this.handleNext();
    }

    renderStep = () => {
        const { activeStep, selectType, deliveryMethod } = this.state;
        switch (activeStep) {
            case 0:
                return (
                    <Step1 />
                )
            case 1:
                return (
                    <Step2
                        onStep2Click={this.onStep2Click}
                        handleGroupSelect={this.handleGroupSelect}
                        handleSelectTypeChange={this.handleSelectTypeChange}
                        handleSelectTypeByClick={this.handleSelectTypeByClick}
                        selectType={selectType}
                        selectedGroup={this.state.selectedGroup}
                        createGroupName={this.state.createGroupName}
                    />
                )
            case 2:
                return (
                    // <FormCreator handleNext={this.formCreatorClick} />
                    <FormBuilderJQstart
                     handleNext={this.handeNextFromFormBuilderJQ}
                     handleBack={this.handleBack}
                     formJq={this.state.formJq} 
                     />
        

                )
            case 3:
                return (
                    <Step3
                    BackFromWidget={this.BackFromWidget}
                    handleBack={this.handleBack}
                        onCreateWidget={this.onCreateWidget}

                        widget={this.state.widget}
                        onShowWidget={() => this.setState({ show: true })}
                        focused={this.resetErrorMessage}

                        deliveryMethod={deliveryMethod}
                        handleDeliveryMethodChange={this.handleDeliveryMethodChange}
                    />
                    // <FormBuilderJQFinish 
                    // handleBack={this.handleBack}
                    // formJq={this.state.formJq}
                    // />
                )

            default:
                return null;
        }
    }

    handleFocus = (event) => event.target.select();


    setFavicon = (favicon, name) => {
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = favicon;
        document.getElementsByTagName('head')[0].appendChild(link);
    };

    handleDeliveryMethodChange = (e) => {
        this.resetErrorMessage();
        const deliveryMethod = e.target.value;
        if (deliveryMethod !== this.state.deliveryMethod) {
            this.setState({ deliveryMethod });
        }
    }

    render() {
        const { activeStep, errorMessage } = this.state;
        if (this.props.user.fetching) return null;
        return (
            <div className='app-wrapper'>
                <div className='root'>
                    <Stepper activeStep={activeStep} />
                    {
                        errorMessage && (
                            <Typography style={{ color: 'red' }}>
                                {errorMessage}
                            </Typography>
                        )
                    }
                    <div className='step-wrapper'>
                        {this.renderStep()}
                    </div>
                </div>


                <Modal
                    open={this.state.show}
                    onClose={this.handleCloseModal}
                    styles={rModalStyles}
                >
                    <div >
                        <div>
                            <Typography variant='body2' >The email address allocated for group "{this.state.groupNameToStore}" is:</Typography>
                            <Typography variant="subtitle2" className="modal-typography"> {this.state.groupMailbox}</Typography>

                            <br />
                            <Typography variant='body2' style={{
                                maxWidth: 555,
                                marginBottom: 25
                            }}>Based on what you selected we have customized your Widget embed code below.
                             Copy this code to your website where you would like the Widget to appear:</Typography>


                        </div>
                        <textarea
                            onFocus={this.handleFocus}
                            className="text-area-test"
                            name="Text1"
                            cols="42"
                            rows="12"
                            defaultValue={this.state.widget}
                        />
                        <div
                            className="modal-btn-container"
                        >
                            <Button
                                style={{
                                    marginTop: '70px',
                                    width: '156px',
                                    display: 'flex'
                                }}
                                className="step2-button-container"
                                onClick={this.handleCloseModal}
                                variant="outlined"
                                color='primary'
                            >
                                Close
                            </Button>

                            <CopyToClipboard text={this.state.widget}>
                                <Button style={{
                                    marginTop: '70px',
                                    width: '156px',
                                    display: 'flex'
                                }}
                                    variant="outlined"
                                    color='primary'
                                >Copy</Button>
                            </CopyToClipboard>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const rModalStyles = {
    modal: {
        top: '20%',
        padding: '40px',
    }
}




const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/widget/components/Main.js